import { AppShell } from './AppShell';
import { CommandPalette } from '../CommandPalette';
import { TweaksPanel } from '../TweaksPanel';

/**
 * AppShellWithOverlays — thin wrapper around <AppShell /> that mounts
 * app-wide overlays (Cmd+K palette, optional Tweaks panel) without modifying
 * AppShell itself.
 *
 * Mounted at the protected-route layout level in App.jsx. The Tweaks panel
 * only renders when the Vite env flag `VITE_TWEAKS=1` is set.
 */
export function AppShellWithOverlays() {
  return (
    <>
      <AppShell />
      <CommandPalette />
      {import.meta.env.VITE_TWEAKS === '1' && <TweaksPanel />}
    </>
  );
}

export default AppShellWithOverlays;
